import { store } from 'shared/stores/core/decorators';
import { getComponentColors } from 'uScope/js/lib/utility/helpers';

@store('IA_RESULT_STYLES')
export class ResultStylesStore {
  state = {
    cssRules: {},
    cssRuleLookup: {},
    counter: 0
  };

  REFRESH_STYLES (store, {data = [], parser}) {
    const evaluateData = (datum) => {
      const key = datum.output;
      const color = parser(key).toLowerCase();
      const name = color.replace('#', '');

      if (!this.state.cssRuleLookup[key]) {
        this.state.cssRuleLookup[key] = name;
      }

      if (!this.state.cssRules[name]) {
        this.state.cssRules[name] = {
          name,
          color,
          rgba: getComponentColors('0x' + name).join(', ')
        };
      }
    };

    data.forEach(evaluateData);

    // For whatever reason Vue doesn't pick up changes to either the Rules or Lookup tables above. Updating the counter
    // helps it notice the change and re-render if needed.
    this.state.counter++;
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/results/ResultStylesStore.js